import UINanoProgress from 'UIComponents/progress/UINanoProgress';
import styled, { theme } from '../../utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedList from 'I18n/components/FormattedList';
import UIIcon from 'UIComponents/icon/UIIcon';
import ACIcon from '../icon/ACIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIList from 'UIComponents/list/UIList';
import UIBadge from 'UIComponents/badge/UIBadge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ThumbnailOverlay = styled.div.withConfig({
  displayName: "ACThumbnailOverlay__ThumbnailOverlay",
  componentId: "sc-6h4wcj-0"
})(["height:100%;width:100%;color:", ";background-color:rgba(0,0,0,", ");"], theme.colors.OLAF, ({
  opacity
}) => 1 - opacity);
const ThumbnailHeader = styled.div.withConfig({
  displayName: "ACThumbnailOverlay__ThumbnailHeader",
  componentId: "sc-6h4wcj-1"
})(["position:absolute;top:0;left:0;width:100%;padding:12px;background:linear-gradient(180deg,rgba(0,0,0,0.6),transparent);display:flex;justify-content:space-between;"]);
const ThumbnailFooter = styled.div.withConfig({
  displayName: "ACThumbnailOverlay__ThumbnailFooter",
  componentId: "sc-6h4wcj-2"
})(["position:absolute;bottom:0;left:0;width:100%;padding:4px 12px;background-color:rgb(0,0,0,0.6);"]);
const ThumnailProgress = ({
  progress
}) => {
  return /*#__PURE__*/_jsx(UINanoProgress, {
    color: progress === 1 ? theme.colors.CALYPSO : theme.colors.SORBET,
    value: progress * 100
  });
};
const CardCompletedMessage = ({
  message = /*#__PURE__*/_jsx(FormattedMessage, {
    message: `academyCommon.progress.completed`
  })
}) => {
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    gap: 4,
    children: [/*#__PURE__*/_jsx(ACIcon, {
      color: theme.colors.CALYPSO,
      name: "checkmark"
    }), message]
  });
};
export const ThumbnailCategories = ({
  categories
}) => {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx(FormattedList, {
      lastWordConnector: ', ',
      twoWordsConnector: ', ',
      wordsConnector: ', ',
      children: categories.map(category => /*#__PURE__*/_jsx(FormattedMessage, {
        message: `academyCommon.categories.${category}`
      }, category))
    })
  });
};
const FooterList = styled(UIList).attrs({
  inline: true,
  use: 'inline-divided'
}).withConfig({
  displayName: "ACThumbnailOverlay__FooterList",
  componentId: "sc-6h4wcj-3"
})(["&&{display:flex;}"]);
const Footer = ({
  children,
  completed = false,
  progress,
  contentType
}) => {
  const isVideo = ['ACADEMY_VIDEO', 'VIDEO'].includes(contentType || '');
  const showFooter = completed || children || isVideo;
  if (showFooter) {
    return /*#__PURE__*/_jsx(ThumbnailFooter, {
      children: isVideo ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ThumnailProgress, {
          progress: completed ? 1 : 0
        }), /*#__PURE__*/_jsxs(FooterList, {
          children: [completed && /*#__PURE__*/_jsx(CardCompletedMessage, {
            message: /*#__PURE__*/_jsx(FormattedMessage, {
              message: `academyCommon.progress.watched`
            })
          }), children]
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ThumnailProgress, {
          progress: progress
        }), /*#__PURE__*/_jsxs(UIFlex, {
          justify: "between",
          children: [completed && /*#__PURE__*/_jsx(CardCompletedMessage, {}), children]
        })]
      })
    });
  }
  return null;
};
const ACThumbnailOverlay = ({
  completed,
  remainingTime,
  contentType,
  categories,
  duration,
  children,
  footer,
  badge
}) => {
  const progress = completed ? 1 : duration && remainingTime ? (duration - remainingTime) / duration : 0;
  return /*#__PURE__*/_jsxs(ThumbnailOverlay, {
    opacity: completed ? 0.6 : 1,
    children: [/*#__PURE__*/_jsxs(ThumbnailHeader, {
      children: [/*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            textTransform: 'uppercase',
            marginBottom: -4,
            marginTop: -4
          },
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: `academyCommon.contentTypes.${contentType}`
          }), contentType === 'CERTIFICATION' && /*#__PURE__*/_jsx(UIIcon, {
            className: "m-left-1",
            color: theme.colors.LORAX,
            name: "certification",
            size: 14
          })]
        }), categories && /*#__PURE__*/_jsx(ThumbnailCategories, {
          categories: categories
        })]
      }), badge && /*#__PURE__*/_jsx(UIBadge, {
        style: {
          height: 'fit-content'
        },
        use: "koala",
        children: badge
      })]
    }), children, /*#__PURE__*/_jsx(Footer, {
      completed: completed,
      contentType: contentType,
      progress: progress,
      children: footer
    })]
  });
};
export default ACThumbnailOverlay;